import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';

import Table from '../../../common/Table';
import Editable from '../../../common/Editable';
import isMobile from 'ismobilejs';
import MobileComponent from './MobileComponent';
import DekstopComponent from './DekstopComponent';
import { showModal } from '../../../../actions/modal';

import { getYandexStoreImageMin } from '../../../../helpers';
import Adaptive from '../../../common/Adaptive';
import { p } from 'react-dom-factories';

const TableWrap = styled('div')`
  .table-row {
    padding: 16px;
    margin: 0 -16px;
    background: white;
    border-top: 1px solid #e3e5e7;
    border-bottom: 1px solid #e3e5e7;
    display: flex;
    justify-content: space-between;
    .editable {
      display: inline-flex;
      margin: 0 5px;
    }

    .table-item-title {
      font-weight: 600;
      margin-bottom: 5px;
    }
    .table-item-art,
    .table-item-id {
      font-size: 11px;
    }
    .table-item-id {
      margin-bottom: 5px;
    }
    .item-remove {
      width: 20px;
      height: 20px;
      flex: none;
      margin-left: 10px;
    }
    .img {
      width: 50px;
      height: 50px;
      margin-right: 16px;
      flex: none;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .right {
      display: flex;
    }
  }
`;

const Wrapper = styled('div')`
  .image-td {
    width: 35px;
    padding-right: 5px !important;
    padding-left: 5px !important;
    .image-block {
      width: 45px !important;
      height: 45px !important;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .table-item {
    .editable {
      min-width: 90px;
    }
  }

  .item-name {
    font-weight: 700;
    color: #343a40;
  }

  .item-article {
    font-size: 10px;
    color: #72747b;
  }

  .item-subname {
    font-size: 10px;
    color: #98a6ad;
  }

  .shortname-td {
    max-width: 300px;
    min-width: 150px;
    .ids-span {
      font-size: 11px;
      color: #98a6ad;
      cursor: pointer;
      font-weight: normal;
    }
  }
`;

const PhysicalSetBlock = (props) => {
  const {
    withoutWrapper,
    currentProduct,
    currentVariant = currentProduct ? currentProduct.variants[0] : null,
    data,
    needAdditionalData,
    handleUpdateSkuSet,
    isNew,
  } = props;

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [currentQuantityInput, setCurrentQuantityInput] = useState(null);
  const [currentQuantityInputValue, setCurrentQuantityInputValue] = useState(null);

  const updateData = (data) => {
    return handleUpdateSkuSet(
      needAdditionalData
        ? data.map((p) => ({
            ...p,
            items: [{ id: p.variantId || p.id, quantity: p.quantity, optional: false }],
          }))
        : data.map((p) => ({ id: p.variantId || p.id, quantity: p.quantity, optional: false })),
    );
  };

  const handleNewItem = () => {
    dispatch(
      showModal('SkuSetAddingProducts', {
        needVariants: true,
        type: 'PHYSICAL_SET',
        currentProducts:
          data?.[0].items?.map((p) => ({ variantId: p.variantId || p.id, quantity: p.quantity })) ??
          [],
        submitCallback: updateData,
      }),
    );
  };

  const handleRemoveItem = async (itemData, itemIndex) => {
    setLoading(true);
    const newSet = data[0].items.slice();
    newSet.splice(itemIndex, 1);
    await updateData(newSet).finally(() => {
      setLoading(false);
    });
  };

  const handleUpdateQuantity = async (value, itemIndex) => {
    const newSet = data[0].items.slice();
    newSet[itemIndex].quantity = value;
    await updateData(newSet).finally(() => {
      setCurrentQuantityInput(null);
    });
  };

  const handleToggleQuantityInput = ({ variantId, quantity }) => {
    setCurrentQuantityInput(variantId);
    setCurrentQuantityInputValue(quantity);
  };
  const tableData = {
    cols: [null, `Товар`, `Количество`],
    rows:
      (data &&
        data[0]?.items?.map((p, i) => ({
          key: p.variantId,
          item: { ...p, id: p.productId },
          data: [
            {
              value: p.images ? (
                p.images[0].url ? (
                  <div
                    className="image-block"
                    style={{
                      backgroundImage: `url(${getYandexStoreImageMin(p.images[0].url, 100)})`,
                    }}
                  />
                ) : null
              ) : null,
              className: 'image-td',
            },
            {
              value: (
                <>
                  <div className="item-name">{p.shortName}</div>
                  {p.article ? <div className="item-article">{`Арт.: ${p.article}`}</div> : null}
                  <div className="item-subname">{p.variantId}</div>
                </>
              ),
              className: 'shortname-td',
            },
            {
              //value: p.quantity
              value: (
                <>
                  <Editable
                    value={
                      currentQuantityInput === p.variantId ? currentQuantityInputValue : p.quantity
                    }
                    currentInput={currentQuantityInput === p.variantId}
                    toggleInput={() => handleToggleQuantityInput(p)}
                    handleUpdate={() => handleUpdateQuantity(currentQuantityInputValue, i)}
                    onChange={(e) => setCurrentQuantityInputValue(e.target.value)}
                    handleCancel={() => setCurrentQuantityInput(null)}
                  />
                  <div>остаток: {p.stockAvailable}шт.</div>
                </>
              ),
            },
          ],
          isRemovable: true,
        }))) ||
      [],
  };

  const tableDataMob = data && data[0].items;

  const TableComponent = (
    <Table
      id="physicalSetTable"
      data={tableData}
      creatable
      bottomCreateButton
      removable
      createLabel="+ Добавить товар в комплект"
      loading={loading}
      handleNewItem={handleNewItem}
      handleRemoveItem={handleRemoveItem}
    />
  );

  if (withoutWrapper) return <Wrapper>{TableComponent}</Wrapper>;

  const adaptiveProps = {
    Wrapper,
    data: isMobile().any ? tableDataMob : data,
    loading,
    handleNewItem,
    handleRemoveItem,
    currentVariant,
    currentQuantityInput: currentQuantityInput,
    currentQuantityInputValue: currentQuantityInputValue,
    handleToggleQuantityInput: handleToggleQuantityInput,
    handleUpdateQuantity: handleUpdateQuantity,
    setCurrentQuantityInputValue: setCurrentQuantityInputValue,
    setCurrentQuantityInput: setCurrentQuantityInput,
    TableComponent: isMobile().any ? undefined : TableComponent,
    TableWrap: isMobile().any ? TableWrap : undefined,
    isNew,
  };

  return (
    <Adaptive
      DekstopComponent={DekstopComponent}
      MobileComponent={MobileComponent}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default PhysicalSetBlock;
